/* 🤖 this file was generated by svg-to-ts */
export var spxIconArrowLeft = {
    name: 'arrow_left',
    data: "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.5 5L8.20711 9.29289C7.87377 9.62623 7.70711 9.79289 7.70711 10C7.70711 10.2071 7.87377 10.3738 8.20711 10.7071L12.5 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>"
};
